var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-container',{staticClass:"mt-4"},[_c('apexchart',{attrs:{"width":"100%","height":"300","options":_vm.options,"series":[],"type":_vm.chartType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }